import { defaultHttpClient } from '../../httpClient';
import type {
  PostRecoverEmailRequest,
  PostRecoverEmailResponse,
} from './types';

/**
 * 아이디(이메일) 찾기 — 입력한 휴대폰 번호로 SMS 인증번호를 발급.
 */
export const postRecoverEmail = (params: PostRecoverEmailRequest) => {
  return defaultHttpClient
    .request<PostRecoverEmailResponse>({
      method: 'POST',
      url: '/api/v2/members/recover_email/',
      data: params,
    })
    .then(result => result.data);
};
